export const mpCodeObj = {
  tysqxiamen: 4,
  tengyunbaotest: 10086
}
